import { render, staticRenderFns } from "./TransferOrders.vue?vue&type=template&id=430e7b37"
import script from "./TransferOrders.vue?vue&type=script&lang=js"
export * from "./TransferOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports